import React, { useState } from "react";
import axios from "axios";
function TestUpload() {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };
  const handleUpload = () => {
    const formData = new FormData();
    formData.append("file", file, "new_filename.ext");

    axios
      .post(
        "http://mua.kpru.ac.th/admission2017/student_waiver/TestUpload",
        formData
      )
      .then((response) => {
        // Handle successful upload
      })
      .catch((error) => {
        // Handle upload error
      });
  };
  return (
    <div>
      <div>
        <label
          for="test"
          className="custom-file-upload btn-block text-center"
        >
          <i className="fa fa-cloud-upload"></i>{" "}
          คลิกอัพโหลดหลักฐานสำเนาบัตรประจำตัวประชาชน *.pdf, รูปภาพ
        </label>
        <input
        id="test"
          className="form-controll w-100"
          style={{ height: "200px" }}
          type="file"
          onChange={handleFileChange}
        />
        <button onClick={handleUpload}>Upload</button>
      </div>
    </div>
  );
}

export default TestUpload;
